import React from "react";

const Albums = () => {

    return(
        <div style={{
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            width:"100%"
        }}>
           
           <h2>Albums</h2>
          

        </div>
    )
}

export default Albums